import React, { useEffect, useContext, useState } from "react";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import axios from "axios";
import { useSnackbar } from "notistack";
import { AuthContext } from "../../context/AuthContext";
import jMoment from "moment-jalaali";
import Grid from "@mui/material/Unstable_Grid2";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { CircularProgress } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";

const MessagesContainer = (props) => {
  const auth = useContext(AuthContext);
  const orderId = props.orderId;
  const [inputMessage, setInputMessage] = useState();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [doctorMessages, setDoctorMessages] = useState([]);
  const [updater, setUpdater] = useState(0);
  useEffect(() => {
    setIsLoading(true);
    axios
      .post(
        "/api/v1/laboratorys/get-order-details",
        {
          orderId: Number(orderId),
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        response.data.data.messages &&
          setDoctorMessages(response.data.data.messages);
        setIsLoading(false);
      })
      .catch((e) => {
        const messages = e.response.data.data;
        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
        setIsLoading(false);
      });
  }, [updater]);

  const submitHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);
    axios
      .post(
        "/api/v1/laboratorys/create-description-order",
        {
          orderId: Number(orderId),
          laboratoryDescription: inputMessage,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        setUpdater((prev) => prev + 1);
        setIsLoading(false);
      })
      .catch((e) => {
        const messages = e.response.data.data;
        setIsLoading(false);
        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
        setIsLoading(false);
      });
  };

  //changing the value of useState
  const changeValueHandler = (event) => {
    setInputMessage(event.target.value);
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Stack
        direction="column"
        spacing={3}
        sx={{ width: "100%", py: 4, px: 1 }}
      >
        {doctorMessages.length !== 0 &&
          doctorMessages.map((m) => {
            return (
              <Stack
                direction="column"
                spacing={1}
                key={m.id}
                sx={{
                  alignSelf: m.doctorDescription ? "flex-end" : "flex-start",
                }}
              >
                {m.doctorDescription?.trim() && (
                  <>
                    <Chip
                      label={jMoment(Number(m.date)).format("jYY/jMM/jDD")}
                      variant="outlined"
                      sx={{ width: "fit-content", alignSelf: "flex-end" }}
                    />
                    <Chip
                      label={m.doctorDescription}
                      color="warning"
                      sx={{ width: "fit-content" }}
                    />
                  </>
                )}
                {m.laboratoryDescription?.trim() && (
                  <>
                    <Chip
                      label={jMoment(Number(m.date)).format("jYY/jMM/jDD")}
                      variant="outlined"
                      sx={{ width: "fit-content" }}
                    />
                    <Chip
                      label={m.laboratoryDescription}
                      color="success"
                      sx={{ width: "fit-content" }}
                    />
                  </>
                )}
              </Stack>
            );
          })}
      </Stack>

      <form onSubmit={submitHandler}>
        <Grid container spacing={2}>
          <Grid xs={12} md={10}>
            <TextField
              value={inputMessage}
              onChange={changeValueHandler}
              size="small"
              id="inputMessage"
              label="پیام"
              variant="outlined"
              multiline={true}
              fullWidth
            />
          </Grid>
          <Grid xs={12} md={2}>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              fullWidth
              sx={{ height: "-webkit-fill-available" }}
            >
              ارسال
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default MessagesContainer;
